<template>

    <div class="content-overlay">

        <div class="in-content del" :class="{ clsng : Global.tempClosingOverlay }">

            <h5>
                <span class="txt-grt">Are you sure?</span>
            </h5>
            
            <p class="c-cap txt-ctr">You are about to delete this row. This operation is irreversible.</p>
            <div class="ctas">
                <div class="btn bck" @click.prevent="close">
                    <span class="txt">Cancel</span>
                </div>
                <div class="btn main txt-blk" @click.prevent="delRow">
                    <span class="hvr"></span>
                    <span class="txt">Yes, delete</span>
                </div>
            </div>

        </div>
        
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'

    export default {

        name: 'DeleteRowOverlay',

        components: {
            
        },

        props: {
            
        },

        data() {
            return {
                Global
            }
        },

        methods: {

            close() {
                this.Global.tempClosingOverlay = true
                setTimeout(() => { this.Global.activeBlurredOverlay = false }, 300)
                setTimeout(() => { this.Global.activeDelRowOverlay = false }, 600)
            },

            delRow() {
                const index = this.Global.rows.findIndex((row) => {
                    return row.id == this.Global.rowIdToDelete
                })

                this.Global.rows.splice(index,1)
                this.close()
            }
        }
    }
</script>